import OurPartners from './OurPartners';
export default OurPartners;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/index.js